import cn from 'classnames'
import { type FC } from 'react'
import styles from './FieldLabel.module.scss'

interface FieldLabelProps {
  label: string;
  optional?: string;
  className?: string;
}

const FieldLabel: FC<FieldLabelProps> = ({ label, optional, className }) => (
  <div className={cn(styles['form-label'], className)}>
    <span className={styles['form-label__text']}>{label}</span>
    {optional !== undefined && optional && (
      <span className={styles['form-label__optional']}>
        (
        {optional}
        )
      </span>
    )}
  </div>
)

export default FieldLabel
